import { User } from "firebase";

export class dbItem {
    
}

export class fbUser {

    constructor(user?:User, firstname?:string, lastname?:string){
        if(user){
            this.uid = user.uid;
            this.email= user.email;
        }
        this.firstname = firstname;
        this.lastname = lastname;
    }

    public uid:string = "";

    public firstname: string = "";

    public lastname: string = "";

    public email:string = "";

    public gender: string= "";

    public dateOfBirth: string= "";

    public phoneNumber: string= "";

    public location: string= "";

    public shippingAddress:fbAddress= new fbAddress();

    public billingAddress:fbAddress = new fbAddress();

    public card:fbCart = new fbCart();

    public isActive:boolean = true;

}


export class fbCart{

    constructor() {
    }
    public cartItems:fbCartItem[] = [];
}

export class fbCartItem{

    constructor( feautres:string,  image:string,  price:number,discount_price:number, quantity:number, name:string, id:string,type:string,size:string) {
        this.features = feautres || "";
        this.image = image || "";
        this.discount_price= discount_price || 0;
        this.price= price|| 0;
        this.quantity=quantity|| 0;
        this.name=name|| "";
        this.id=id|| "";
        this.type=type|| "";
        this.size = size|| "";
     }
    public id: string= "";

    public features: string= "";

    public quantity:number= 0;

    public image: string= "";

    public name: string="";

    public discount_price: number=0;

    public price: number=0;

    public type: string="";

    public size: string="";
}



export class fbOrder{

    constructor() {
    }
    public orderId: string= "";

    public date: string= "";
        
    public price: string= "";

    public paidPrice: string= "";

    public buyerId: string= "";

    public shippingAddress: fbAddress;

    public billingAddress: fbAddress;

    public products: fbCartItem[]=[];

    public status: string= "";

    public shippingPrice:string = "";
}

export enum OrderStatus{
    Accepted =1,
    Canceled = 2 // To be continue
}

export class fbAddress{

    constructor() {
    }
    public name: string= "";

    public address: string= "";

    public buildingName: string= "";

    public streetNo: string= "";

    public state: string= "";

    public zip: string= "";

    public country: string= "";
}

export class fbShippingMetric{

    constructor( public shippingPrice:number, public feeFrom:number) {

    }
}